import {Alert} from 'components';
import React from 'react';
import {apiAuth, navigate} from 'services';
import CompChangeSuccess from './CompChangeSuccess';
import {getUuid, Log, parseMultilanguage} from 'utils';
import {Ecolors, Icons} from 'constant';

export const validateData = (p: Object, content?: string) => {
  let flag = true;
  Object.keys(p).map((item, index) => {
    if (!p?.[item]) {
      flag = false;
      Alert.showError({
        content: content || 'changecmnd.thongtinkhongduocdetrong',
      });
    }
  });
  return flag;
};

export const validateDate = (
  p: {
    date: any;
    fromdate: any;
    todate: any;
  },
  content: string,
) => {
  const dd = new Date(`${p.date.year}-${p.date.month}-${p.date.date}`);
  if (!validateData(p.date, content)) {
    return false;
  }
  if (dd < p.fromdate || dd > p.todate) {
    Alert.showError({
      content: content || 'changecmnd.thongtinkhongduocdetrong',
    });
    return false;
  }
  return true;
};

export const convertchangeIdNoStatus = (status: string) => {
  switch (status) {
    case 'PENDING':
      return {
        title: parseMultilanguage(`changecmnd.${status}`),
        content: parseMultilanguage(`changecmnd.${status}_note`),
        icon: Icons.pending,
        color: Ecolors.yellowColor,
      };
    case 'REJECT':
      return {
        title: parseMultilanguage(`changecmnd.${status}`),
        content: parseMultilanguage(`changecmnd.${status}_note`),
        icon: Icons.reject,
        color: Ecolors.redColor,
      };
    default:
      return {
        title: parseMultilanguage(`changecmnd.${status}`),
        content: parseMultilanguage(`changecmnd.${status}_note`),
        icon: Icons.pending,
        color: Ecolors.yellowColor,
      };
  }
};

export const submitForm = async ({
  file,
  idNo,
  dateOfIssue,
  placeOfIssue,
  photoBeforeURL,
  photoAfterURL,
  expireDateOfIdNo,
  name = '',
  dob = '',
}) => {
  try {
    if (
      validateData({
        file,
        idNo,
        dateOfIssue,
        placeOfIssue,
        photoBeforeURL,
        photoAfterURL,
      })
    ) {
      const resFetch = await fetch(file);
      const blob = await resFetch.blob();
      const id = getUuid();

      const fileImg = new File([blob], `${id}.png`, {
        type: 'image/png',
      });

      const formdata = new FormData();
      formdata.append('file', fileImg);
      formdata.append('idNo', idNo);
      formdata.append('dateOfIssue', dateOfIssue); // yyyyMMDD
      formdata.append('placeOfIssue', placeOfIssue);
      formdata.append('photoBeforeURL', photoBeforeURL);
      formdata.append('photoAfterURL', photoAfterURL);
      formdata.append('expireDateOfIdNo', expireDateOfIdNo); // yyyyMMDD
      name && formdata.append('name', name);
      dob && formdata.append('dob', dob);
      const res = await apiAuth.changeIdNoCreate(formdata);
      if (res.status == 200) {
        navigate('OtpRequestModal', {
          data: {
            requestOnSendOtp: res.data?.otpInfo,
            flowApp: 'ChangeIDNo',
          },
          onConfirm: () => {
            return Alert.showComponent({
              component: () => (
                <CompChangeSuccess
                  content="changecmnd.capnhatcmndcccdthanhcong"
                  onConfirm={() => {
                    navigate('AccountInfoModal');
                  }}
                />
              ),
            });
          },
        });
        return;
      }
      Alert.showError({
        multilanguage: false,
        content: res.message,
      });
    }
  } catch (error: any) {
    Alert.showError({
      multilanguage: false,
      content: error.message,
    });
  }
};
